import { render } from "./NavBar.vue?vue&type=template&id=a053933a&scoped=true&ts=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=a053933a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a053933a"]])

export default __exports__